/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import type { SsoAuthMethod } from '../../utils/loginSignupAnalyticsUtils';
import type { StyleProp, ViewStyle } from 'react-native';
import type { PhoneVerificationChannel, Purpose } from '../../managers/sso';
import type { OnOtpVerified } from '../../hooks/otp/types';

/** @deprecated Use `PhoneVerificationChannel` from managers/sso. */
export type VerifyAccountOtpRequestChannel = PhoneVerificationChannel;

export type VerifyPhoneViewProps = {
  purpose?: Purpose;
  phoneNumber?: string;
  dialingCode?: string;
  availableChannels?: PhoneVerificationChannel[];
  onVerified?: OnOtpVerified;
  onUpdateMobileNumber?: () => void;
  showTitle?: boolean;
  testID?: string;
  showUpdateMobile?: boolean;
  /** Sign-up method used in analytics. */
  signupMethod?: SsoAuthMethod;
  containerStyle?: StyleProp<ViewStyle>;
};

export function resolvePrimaryOtpChannel(
  channels: PhoneVerificationChannel[],
): PhoneVerificationChannel | undefined {
  if (channels.includes('sms')) return 'sms';
  if (channels.includes('whatsapp')) return 'whatsapp';
  return undefined;
}
